import diaryIcon from '../../../asset/svg/diary.svg';
import diarySize30Icon from '../../../asset/svg/diary-size30.svg';
import { RecipeCreatorNameImage } from '../../../type';
import {
  defaultProfilePhoto,
  notificationBadgeIcon,
} from '../../../utils/common/variables';
import { CommunityGtm } from '../../../utils/gtm/community/communityGtm';
import { useHasUnreadNotificationsQuery } from '../../../utils/hook/react-query/recipe/useHasUnreadNotificationsQuery';
import { useHistoryMethod } from '../../../utils/hook/useHistoryMethod';

const CreatorButton = ({
  size = 24,
  recipeCreatorNameImage,
}: {
  size?: 24 | 30 | 32;
  recipeCreatorNameImage?: RecipeCreatorNameImage;
}) => {
  const { hasUnreadNotifications } = useHasUnreadNotificationsQuery();
  const history = useHistoryMethod();

  const imgSrc = {
    24: diaryIcon.src,
    30: diarySize30Icon.src,
    32: recipeCreatorNameImage?.profileImage || defaultProfilePhoto,
  }[size];

  const imgWidthAndHeight = {
    24: 'w-24px h-24px',
    30: 'w-30px h-30px',
    32: 'w-32px h-32px',
  }[size];

  const isRecipeDetailBTB = size === 32;

  const handleClick = () => {
    if (recipeCreatorNameImage) {
      history.push(
        `/recipes/creator/${recipeCreatorNameImage.name}?category=recipe`,
      );
      return;
    }

    new CommunityGtm().click_my_diary();
    history.push('/mypages/creator');
  };

  return (
    <div className="flex-center absolute right-0 ">
      <button
        onClick={handleClick}
        data-testid="creator-page-link"
        className="relative"
        style={{ width: size, height: size }}
        type="button"
      >
        {isRecipeDetailBTB ? (
          <img
            src={imgSrc}
            alt="크리에이터"
            className={`rounded-full object-cover object-center ${imgWidthAndHeight}`}
            width={size}
            height={size}
          />
        ) : (
          <img src={imgSrc} alt="크리에이터" />
        )}
        {hasUnreadNotifications && (
          <img
            src={notificationBadgeIcon}
            width={11}
            height={11}
            alt="알림"
            className="absolute -top-2px right-0"
          />
        )}
      </button>
    </div>
  );
};

export default CreatorButton;
